<template>
  <v-card elevation="1">
    <v-card-title class="d-flex flex-row" style="color: var(--darkBlue)">
      <v-row>
        <v-col class="text-lg-left text-center" lg="12" cols="12">
          <h3>{{ $t('navigationDrawerMenu.constantsManagement') }}</h3>
        </v-col>
      </v-row>
      <div>
        <RefreshButton :refreshFunction="() => getItems()"></RefreshButton>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <ValidationObserver ref="actionsOnFormObserver" v-slot="{ handleSubmit }">
        <form
          @submit.prevent="handleSubmit(submitForm)"
        >
          <v-card-text>
            <v-row>
              <FormElement
                  v-for="(element, index) in formItems"
                  :key="
                    element.key.parent + '_' + element.key.child + '_' + index
                  "
                  v-model="$data[element.key.parent][element.key.child]"
                  :validationLabel="$t(element.validationLabel)"
                  :rules="element.rules"
                  :formLabel="$t(element.formLabel)"
                  :onChange="element.onChange"
                  :formType="element.formType"
                  :lg="element.lg"
                  :cols="element.cols"
                  :disabled="element.disabled"
                  :hidden="element.hidden"
                  :labelShown="element.labelShown"
                  :active="element.active"
                  :topLabel="element.topLabel"
                  :placeholder="$t(element.placeholder)"
                />
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              style="
                color: #fff;
                text-transform: unset !important;
                background-color: #0077d5;

                padding: 1vh 1vh;
                border-radius: 30px !important;
                font-weight: bolder;
                font-size: medium;
              "
              elevation="0"
              class="darken-1"
              type="submit"
              :loading="$store.state.loadingStatus"
              >{{ $t('buttons.save') }}</v-btn
            >
          </v-card-actions>
        </form>
      </ValidationObserver>
    </v-card-text>
    
  </v-card>
</template>
<script>
import AdminService from '../services/AdminService';
import { removeNullValues } from '../utils/constants';
import FormElement from '../components/FormElement.vue';
import RefreshButton from '../components/RefreshButton.vue';

export default {
  data() {
    return {
      items: null,
      form: {},
    };
  },
  components: { FormElement, RefreshButton },
  mounted() {
    this.setup();

  },
  computed: {
    formItems(){
      let items = [];
      if(this.items){
        items = Object.entries(this.items).map(item => {
          return {
            key: {
              parent: 'form',
              child: item[0],
            },
            validationLabel: `labels.constantLabels.${item[0]}`,
            rules: 'numeric',
            formType: {
              name: 'text'
            },
            lg: 4,
            labelShown: false,
            topLabel: true,
            cols: 12,
            placeholder: `labels.constantLabels.${item[0]}`
          };
        })
      }
      return items;
      
    },
  },
  methods: {

    async setup() {
      this.getItems();
    },

    getItems() {
      this.$store.state.loadingStatus = true;

      AdminService.getAdminConstantList()
      .then((response) => {
        this.items = response.data.Result;
        this.form = this.items;
        this.totalItems = response.data.TotalItems;
      })
      .catch(window.showError)
      .finally(() => {
        this.$store.state.loadingStatus = false;
      });
    },

    async submitForm(){
      this.$store.state.loadingStatus = true;
      let body = removeNullValues(this.form);
      AdminService.updateAdminConstants(body)
      .then(async response => {
        window.showSuccess(this.$t(`messages.successfulUpdateGeneral`))
        this.getItems();
      })
      .catch(window.showError)
      .finally(() => {
        this.$store.state.loadingStatus = false;
      })
    },
  },
};
</script>
<style></style>
